import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "@phosphor-icons/react";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "@/components/ui/select";
import { SUPPORTED_LANGS } from "@/i18n";

/**
 * Compact language switcher used in the landing nav and dashboard topbar.
 * Persists to localStorage via i18next's LanguageDetector ("vs-i18n-lang").
 */
export default function LanguageSwitcher({ className = "", compact = false }) {
  const { i18n, t } = useTranslation();
  const change = (code) => {
    i18n.changeLanguage(code);
    // Force-update HTML lang attribute for screen readers + CSS hooks.
    if (typeof document !== "undefined") {
      document.documentElement.setAttribute("lang", code);
    }
  };

  return (
    <div className={`inline-flex items-center gap-1.5 ${className}`} data-testid="lang-switcher">
      <Globe size={compact ? 14 : 16} className="text-[var(--vs-text-secondary)]" />
      <Select value={i18n.resolvedLanguage || "en"} onValueChange={change}>
        <SelectTrigger
          className={compact ? "h-7 text-xs border-0 bg-transparent gap-1 px-1.5 focus:ring-0" : "h-8 text-xs min-w-[120px]"}
          aria-label={t("login.language", "Language")}
          data-testid="lang-switcher-trigger"
        >
          <SelectValue placeholder="EN" />
        </SelectTrigger>
        <SelectContent>
          {SUPPORTED_LANGS.map((l) => (
            <SelectItem key={l.code} value={l.code} data-testid={`lang-option-${l.code}`}>
              <span className="font-mono mr-1.5 text-[10px] uppercase">{l.code}</span>
              {l.native}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
